import stepConclusionsComponent from './stepConclusionsComponent';

const stepConclusionsModule = angular.module('app.stepConclusions', [require('angular-chart.js')])
    .component('stepConclusions', stepConclusionsComponent);

export default stepConclusionsModule;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepConclusions/index.js